import Vue from "vue";
import axios from "axios";
import { field } from "./consts";
import * as utils from "@/assets/js/utils";
import { MessageBox } from "element-ui";
import { CodeToText, TextToCode } from "element-china-area-data";

// if (field.production) {
//   var targetProtocol = "https:";
//   if (window.location.protocol != targetProtocol) {
//     window.location.href =
//       targetProtocol +
//       window.location.href.substring(window.location.protocol.length);
//   }
//   console.log = function () { };
// }

axios.defaults.timeout = 100000;
axios.defaults.baseURL = field.domain;

//http请求拦截器
axios.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// http响应拦截器
axios.interceptors.response.use(
  response => {
    //store.commit(SET_FETCH_LOADING, false)
    // if (response.data.code == "402") {
    //     toUrl("'/oauth/login-account'")
    // }
    if (response.data.biz_msg == "数据令牌失效，请重新授权") {
      window.localStorage.clear();
      window.sessionStorage.clear();
      utils.openLogin();
    }
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);

Vue.prototype.utils = utils;
Vue.prototype.field = field;
Vue.prototype._global_ = _global_;

_global_.cacheData = new Map();
window.getCache = function (data) {
  let temp = _global_.cacheData.get(window.location.href);
  return temp ? temp : data;
};

/**
 * 访问服务
 */
Vue.prototype.api = function (name, data, cache) {
  // if (loding == undefined) {
  //     loding = false
  // }
  // if (loding) {
  //     this.utils.showLoading();
  // }
  if (_global_.uploadIng.length > 0 && name != "100999") {
    alert("请等待文件上传完成.");
    return Promise.reject({});
  }
  let request = {
    // app_key: document.domain,
    app_key: 'localhost',
    app_id: field.appId,
    method: name,
    debug: "true"
  };
  let token = this.utils.getToken();
  if (token) {
    request.token = token.replace('"', "").replace('"', "");
  }
  if (cache) {
    _global_.cacheData.set(window.location.href, data);
  }
  if (data) {
    request.content = data;
  }

  return axios.post("/gateway.do", request).then(res => {
    return Promise.resolve(res.data);
  });
};

window.alert = function (msg, func) {
  MessageBox.alert(msg, "提示", {
    confirmButtonText: "确定",
    callback: func == undefined ? action => { } : func
  });
};
window.confirm = function (msg, func) {
  MessageBox.confirm(msg, "提示", {
    confirmButtonText: "确定",
    callback: action => {
      if (action == "confirm") {
        func();
      }
    }
  });
};

//将地址汉字转换成code
window.toCode = function (bA = [], fA = [], bs, bc, ba, fs, fc, fa) {
  let codeArr = {};
  let temp = TextToCode[bs];
  bA.push(temp == undefined ? "" : temp.code);
  if (temp != undefined) {
    temp = TextToCode[bs][bc];
    bA.push(temp == undefined ? "" : temp.code);
    if (temp != undefined) {
      temp = TextToCode[bs][bc][ba];
      bA.push(temp == undefined ? "" : temp.code);
    }
  }
  temp = TextToCode[fs];
  fA.push(temp == undefined ? "" : temp.code);
  if (temp != undefined) {
    temp = TextToCode[fs][fc];
    fA.push(temp == undefined ? "" : temp.code);
    if (temp != undefined) {
      temp = TextToCode[fs][fc][fa];
      fA.push(temp == undefined ? "" : temp.code);
    }
  }
  codeArr.beginAddress = bA;
  codeArr.finishAddress = fA;
  return codeArr;
};
//正则对象
const Reg = {
  //手机号
  checkPhone: function (rule, value, callback) {
    let reg = /^1(2|3|4|5|6|7|8|9)\d{9}$/;
    if (value != null && value != "") {
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error("您输入的手机号有误!"));
      }
    } else {
      callback(new Error("手机号不能为空"));
    }
  },
  //登录密码
  checkPwd: function (rule, value, callback) {
    let reg = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>,.\/]).{8,16}/;
    if (value != null && value != "") {
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error("密码必须是8-16位字母+数字+特殊符号"));
      }
    } else {
      callback(new Error("密码不能为空"));
    }
  },
  //身份证号
  checkIdNumber: function (rule, value, callback) {
    let reg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
    if (value != null && value != "") {
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error("您输入的身份证号有误!"));
      }
    } else {
      callback(new Error("身份证号不能为空"));
    }
  },
  //身份证号
  checkIdNumber_null: function (rule, value, callback) {
    let reg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
    if (value != null && value != "") {
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error("您输入的身份证号有误!"));
      }
    } else {
      callback();
    }
  },
  payPwd: function (rule, value, callback) {
    if (/^[0-9]{6}$/.test(value)) {
      callback();
    } else if (!value || value == null) {
      callback(new Error("密码不能为空"));
    } else {
      callback(new Error("请输入6位数字"));
    }
  },
  //纯数字
  checkNumber: function (rule, value, callback) {
    if (/^([0-9]+\.)?[0-9]+$/.test(value)) {
      callback();
    } else if (!value || value == null) {
      callback(new Error("该输入项为必填项!"));
    } else {
      callback(new Error("请输入数字"));
    }
  },
  //运费转信息费
  checkTotal: function (rule, value, callback) {
    if (/^([0-9]+\.)?[0-9]+$/.test(value) && value > 0) {
      callback();
    } else if (!value || value == null) {
      callback(new Error("该输入转换金额!"));
    } else {
      callback(new Error("请输入正确金额"));
    }
  },
  //纯数字非必填
  checkNumber_null: function (rule, value, callback) {
    if (/^([0-9]+\.)?[0-9]+$/.test(value)) {
      callback();
    } else if (!value || value == null) {
      callback();
    } else {
      callback(new Error("请输入合理数值"));
    }
  },
  //车牌号
  checkCar: function (rule, value, callback) {
    let reg = /(^[\u4E00-\u9FA5]{1}[A-Z0-9]{6}$)|(^[A-Z]{2}[A-Z0-9]{2}[A-Z0-9\u4E00-\u9FA5]{1}[A-Z0-9]{4}$)|(^[\u4E00-\u9FA5]{1}[A-Z0-9]{5}[挂学警军港澳]{1}$)|(^[A-Z]{2}[0-9]{5}$)|(^(08|38){1}[A-Z0-9]{4}[A-Z0-9挂学警军港澳]{1}$)/;
    if (value != null && value != "") {
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error("您输入的车牌号有误!"));
      }
    } else {
      callback(new Error("车牌号不能为空"));
    }
  },
};

/**
 * 表单验证
 */
Vue.prototype.filter_rules = function (isRequire = true, type = "") {
  let rules = [];
  switch (type) {
    case "phone":
      rules.push({
        validator: Reg.checkPhone,
        required: isRequire,
        trigger: "blur"
      });
      break;
    case "pwd":
      rules.push({
        validator: Reg.checkPwd,
        required: isRequire,
        trigger: "blur"
      });
      break;
    case "idNumber":
      rules.push({
        validator: Reg.checkIdNumber,
        required: isRequire,
        trigger: "blur"
      });
      break;
    case "idNumber_null":
      rules.push({
        validator: Reg.checkIdNumber_null,
        required: isRequire,
        trigger: "blur"
      });
      break;
    case "number":
      rules.push({
        validator: Reg.checkNumber,
        required: isRequire,
        trigger: "blur"
      });
      break;
    case "number_null":
      rules.push({
        validator: Reg.checkNumber_null,
        required: isRequire,
        trigger: "blur"
      });
      break;
    case "payPwd":
      rules.push({
        validator: Reg.payPwd,
        required: isRequire,
        trigger: "blur"
      });
      break;
    case "total":
      rules.push({
        validator: Reg.checkTotal,
        required: isRequire,
        trigger: "blur"
      });
      break;
    case "car":
      rules.push({
        validator: Reg.checkCar,
        required: isRequire,
        trigger: "blur"
      });
      break;
    default:
      rules.push({
        required: isRequire,
        message: "该输入项为必填项!",
        trigger: "blur"
      });
      break;
  }
  return rules;
};

/**
 * 表单验证
 */
Vue.prototype.required = function (message) {
  return this.filter_rules();
};



// WEBPACK FOOTER //
// ./src/assets/js/global.js